/**
 * Shift-aware date utilities.
 * Operations run in 3 × 8-hour shifts starting at 04:00 IST.
 * A "shift day" = 04:00 IST on date D → 03:59:59 IST on date D+1.
 */

const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000; // 5h30m in milliseconds
const SHIFT_START_HOUR = 4; // 4 AM IST

/**
 * Returns today's operational shift date as "YYYY-MM-DD".
 * If current IST time is before 04:00, returns yesterday's IST date.
 */
export function getShiftDate(now = new Date()) {
  const istMs = now.getTime() + IST_OFFSET_MS;
  const ist = new Date(istMs);
  const hour = ist.getUTCHours();
  if (hour < SHIFT_START_HOUR) {
    const prev = new Date(istMs - 24 * 60 * 60 * 1000);
    return prev.toISOString().slice(0, 10);
  }
  return ist.toISOString().slice(0, 10);
}

/**
 * Returns the first day of the current operational month as "YYYY-MM-DD".
 */
export function getShiftMonthStart(now = new Date()) {
  const today = getShiftDate(now);
  return today.slice(0, 7) + '-01';
}
